import styled, { css } from 'styled-components'

import ButtonStyled from 'components/Editor/EditorElements/courseKit/DropdownMenuCourse/styled/ButtonStyled'

const mobileStyles = css`
  padding: 16px;
`

const desktopStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  font-size: 11px;
  transform: translate(100%, 0);
`

export const CloseButtonStyled = styled(ButtonStyled)<{ $display: 'mobile' | 'desktop' }>`
  position: absolute;
  top: 0;
  right: 0;
  color: var(--color-background-main);
  cursor: pointer;

  ${({ $display }) => ($display === 'mobile' ? mobileStyles : desktopStyles)}
`
